import * as React from 'react';
import classnames from 'classnames';
import { useDrawer } from '../../context/DrawerContext.js';

const DrawerContent = ({ isContained =true , children ,  })=>{
    const { direction  } = useDrawer();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('drawer-content', `drawer-content--${direction}`, {
            'drawer-content--is-contained': isContained
        })
    }, children);
};

export { DrawerContent };
//# sourceMappingURL=DrawerContent.js.map
